import API from './api';

var putOrPatch = function (path, data) {
  return API.put(path, data).catch(function (error) {
    if (error && error.response && (error.response.status === 405 || error.response.status === 404)) {
      return API.patch(path, data);
    }
    return Promise.reject(error);
  });
};

var getFirstAvailable = function (paths) {
  var index = 0;
  var next = function () {
    return API.get(paths[index]).catch(function (error) {
      var status = error && error.response && error.response.status;
      index += 1;
      if (status === 404 && index < paths.length) {
        return next();
      }
      return Promise.reject(error);
    });
  };
  return next();
};

var formDataToObject = function (data) {
  if (!data || typeof data.entries !== 'function') return data;
  var payload = {};
  data.forEach(function (value, key) {
    payload[key] = value;
  });
  if (payload.order !== undefined && payload.order !== '') {
    payload.order = Number(payload.order);
  }
  if (payload.status !== 'active' && payload.status !== 'inactive') {
    payload.status = 'active';
  }
  return payload;
};

// Main Section Endpoints
export var getAboutMain = function () {
  return getFirstAvailable(['/admin/about', '/about']);
};

export var createAboutMain = function (data) {
  return API.post('/admin/about', data).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.post('/about', data);
    }
    return Promise.reject(err);
  });
};

export var updateAboutMain = function (id, data) {
  return putOrPatch('/admin/about/' + id, data).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return putOrPatch('/about/' + id, data);
    }
    return Promise.reject(err);
  });
};

export var deleteAboutMain = function (id) {
  return API.delete('/admin/about/' + id).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.delete('/about/' + id);
    }
    return Promise.reject(err);
  });
};

// Statistics Endpoints
export var getAllStatistics = function () {
  return getFirstAvailable(['/admin/about/statistics', '/about/statistics']);
};

export var createStatistic = function (data) {
  var payload = formDataToObject(data);
  return API.post('/admin/about/statistics', payload).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.post('/about/statistics', payload);
    }
    return Promise.reject(err);
  });
};

export var updateStatistic = function (id, data) {
  var payload = formDataToObject(data);
  return putOrPatch('/admin/about/statistics/' + id, payload).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return putOrPatch('/about/statistics/' + id, payload);
    }
    return Promise.reject(err);
  });
};

export var deleteStatistic = function (id) {
  return API.delete('/admin/about/statistics/' + id).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.delete('/about/statistics/' + id);
    }
    return Promise.reject(err);
  });
};

// Features / Crafted With Purpose Endpoints
export var getAllFeatures = function () {
  return getFirstAvailable(['/admin/about/purpose', '/about/purpose']);
};

export var createFeature = function (data) {
  var payload = formDataToObject(data);
  return API.post('/admin/about/purpose', payload).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.post('/about/purpose', payload);
    }
    return Promise.reject(err);
  });
};

export var updateFeature = function (id, data) {
  var payload = formDataToObject(data);
  return putOrPatch('/admin/about/purpose/' + id, payload).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return putOrPatch('/about/purpose/' + id, payload);
    }
    return Promise.reject(err);
  });
};

export var deleteFeature = function (id) {
  return API.delete('/admin/about/purpose/' + id).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.delete('/about/purpose/' + id);
    }
    return Promise.reject(err);
  });
};

// Team Members Endpoints
export var getAllTeamMembers = function () {
  return getFirstAvailable(['/admin/about/team', '/about/team']);
};

export var createTeamMember = function (data) {
  return API.post('/admin/about/team', data).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.post('/about/team', data);
    }
    return Promise.reject(err);
  });
};

export var updateTeamMember = function (id, data) {
  return putOrPatch('/admin/about/team/' + id, data).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return putOrPatch('/about/team/' + id);
    }
    return Promise.reject(err);
  });
};

export var deleteTeamMember = function (id) {
  return API.delete('/admin/about/team/' + id).catch(function (err) {
    if (err && err.response && (err.response.status === 404 || err.response.status === 405)) {
      return API.delete('/about/team/' + id);
    }
    return Promise.reject(err);
  });
};
